<script lang="ts">
	export let marginTop = false
	export let marginBottom = false
</script>

<div
	class="menu-item-separator"
	class:marginTop={marginTop === true}
	class:marginBottom={marginBottom === true}
/>

<style lang="postcss">
	.menu-item-separator {
		@apply border-b border-gray-500;
	}
	.marginTop {
		margin-top: 25px;
	}
	.marginBottom {
		margin-bottom: 25px;
	}
</style>
